export default "__VITE_ASSET__34b8909a__"